<template>
    <ul class="pagination mt-2">
        <li class="page-item previous disabled">
            <a href="#" data-dt-idx="0" tabindex="0"
               class="page-link">&nbsp;</a></li>
        <li class="page-item next disabled">
            <a href="#" class="page-link">&nbsp;</a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "withPagination"
    }
</script>

<style scoped>

</style>
